/* generated by Svelte v3.31.0 */
import { SvelteComponent, binding_callbacks, create_slot, detach, element, init, insert, listen, safe_not_equal, set_custom_element_data, transition_in, transition_out, update_slot } from "svelte/internal";
import { define } from "../lib";
import { VmYoutube, VmEmbed } from "@vime/core";
import { createEventDispatcher, onMount } from "svelte";
import { setProp } from "../lib";
function create_fragment(ctx) {
    let vm_youtube;
    let current;
    let mounted;
    let dispose;
    const default_slot_template = /*#slots*/ ctx[20].default;
    const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[19], null);
    return {
        c() {
            vm_youtube = element("vm-youtube");
            if (default_slot)
                default_slot.c();
            set_custom_element_data(vm_youtube, "class", /*className*/ ctx[0]);
            set_custom_element_data(vm_youtube, "style", /*style*/ ctx[1]);
            set_custom_element_data(vm_youtube, "cookies", /*cookies*/ ctx[2]);
            set_custom_element_data(vm_youtube, "video-id", /*videoId*/ ctx[3]);
            set_custom_element_data(vm_youtube, "show-fullscreen-control", /*showFullscreenControl*/ ctx[4]);
            set_custom_element_data(vm_youtube, "poster", /*poster*/ ctx[5]);
            set_custom_element_data(vm_youtube, "language", /*language*/ ctx[6]);
            set_custom_element_data(vm_youtube, "autoplay", /*autoplay*/ ctx[7]);
            set_custom_element_data(vm_youtube, "controls", /*controls*/ ctx[8]);
            set_custom_element_data(vm_youtube, "loop", /*loop*/ ctx[9]);
            set_custom_element_data(vm_youtube, "muted", /*muted*/ ctx[10]);
            set_custom_element_data(vm_youtube, "playsinline", /*playsinline*/ ctx[11]);
        },
        m(target, anchor) {
            insert(target, vm_youtube, anchor);
            if (default_slot) {
                default_slot.m(vm_youtube, null);
            }
            /*vm_youtube_binding*/ ctx[21](vm_youtube);
            current = true;
            if (!mounted) {
                dispose = listen(vm_youtube, "vmLoadStart", /*onEvent*/ ctx[13]);
                mounted = true;
            }
        },
        p(ctx, [dirty]) {
            if (default_slot) {
                if (default_slot.p && dirty & /*$$scope*/ 524288) {
                    update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[19], dirty, null, null);
                }
            }
            if (!current || dirty & /*className*/ 1) {
                set_custom_element_data(vm_youtube, "class", /*className*/ ctx[0]);
            }
            if (!current || dirty & /*style*/ 2) {
                set_custom_element_data(vm_youtube, "style", /*style*/ ctx[1]);
            }
            if (!current || dirty & /*cookies*/ 4) {
                set_custom_element_data(vm_youtube, "cookies", /*cookies*/ ctx[2]);
            }
            if (!current || dirty & /*videoId*/ 8) {
                set_custom_element_data(vm_youtube, "video-id", /*videoId*/ ctx[3]);
            }
            if (!current || dirty & /*showFullscreenControl*/ 16) {
                set_custom_element_data(vm_youtube, "show-fullscreen-control", /*showFullscreenControl*/ ctx[4]);
            }
            if (!current || dirty & /*poster*/ 32) {
                set_custom_element_data(vm_youtube, "poster", /*poster*/ ctx[5]);
            }
            if (!current || dirty & /*language*/ 64) {
                set_custom_element_data(vm_youtube, "language", /*language*/ ctx[6]);
            }
            if (!current || dirty & /*autoplay*/ 128) {
                set_custom_element_data(vm_youtube, "autoplay", /*autoplay*/ ctx[7]);
            }
            if (!current || dirty & /*controls*/ 256) {
                set_custom_element_data(vm_youtube, "controls", /*controls*/ ctx[8]);
            }
            if (!current || dirty & /*loop*/ 512) {
                set_custom_element_data(vm_youtube, "loop", /*loop*/ ctx[9]);
            }
            if (!current || dirty & /*muted*/ 1024) {
                set_custom_element_data(vm_youtube, "muted", /*muted*/ ctx[10]);
            }
            if (!current || dirty & /*playsinline*/ 2048) {
                set_custom_element_data(vm_youtube, "playsinline", /*playsinline*/ ctx[11]);
            }
        },
        i(local) {
            if (current)
                return;
            transition_in(default_slot, local);
            current = true;
        },
        o(local) {
            transition_out(default_slot, local);
            current = false;
        },
        d(detaching) {
            if (detaching)
                detach(vm_youtube);
            if (default_slot)
                default_slot.d(detaching);
            /*vm_youtube_binding*/ ctx[21](null);
            mounted = false;
            dispose();
        }
    };
}
define("vm-youtube", VmYoutube);
define("vm-embed", VmEmbed);
function instance($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope } = $$props;
    let __ref;
    let __mounted = false;
    const dispatch = createEventDispatcher();
    let { class: className } = $$props;
    let { style } = $$props;
    let { cookies = false } = $$props;
    let { videoId } = $$props;
    let { showFullscreenControl = true } = $$props;
    let { poster = undefined } = $$props;
    let { language = "en" } = $$props;
    let { autoplay = false } = $$props;
    let { controls = false } = $$props;
    let { logger = undefined } = $$props;
    let { loop = false } = $$props;
    let { muted = false } = $$props;
    let { playsinline = false } = $$props;
    const getAdapter = (...args) => __ref.getAdapter(...args);
    const ref = () => __ref;
    const getWebComponent = () => __ref;
    onMount(() => {
        $$invalidate(18, __mounted = true);
    });
    const onEvent = e => {
        e.stopPropagation();
        dispatch(e.type, e.detail);
    };
    function vm_youtube_binding($$value) {
        binding_callbacks[$$value ? "unshift" : "push"](() => {
            __ref = $$value;
            $$invalidate(12, __ref);
        });
    }
    $$self.$$set = $$props => {
        if ("class" in $$props)
            $$invalidate(0, className = $$props.class);
        if ("style" in $$props)
            $$invalidate(1, style = $$props.style);
        if ("cookies" in $$props)
            $$invalidate(2, cookies = $$props.cookies);
        if ("videoId" in $$props)
            $$invalidate(3, videoId = $$props.videoId);
        if ("showFullscreenControl" in $$props)
            $$invalidate(4, showFullscreenControl = $$props.showFullscreenControl);
        if ("poster" in $$props)
            $$invalidate(5, poster = $$props.poster);
        if ("language" in $$props)
            $$invalidate(6, language = $$props.language);
        if ("autoplay" in $$props)
            $$invalidate(7, autoplay = $$props.autoplay);
        if ("controls" in $$props)
            $$invalidate(8, controls = $$props.controls);
        if ("logger" in $$props)
            $$invalidate(14, logger = $$props.logger);
        if ("loop" in $$props)
            $$invalidate(9, loop = $$props.loop);
        if ("muted" in $$props)
            $$invalidate(10, muted = $$props.muted);
        if ("playsinline" in $$props)
            $$invalidate(11, playsinline = $$props.playsinline);
        if ("$$scope" in $$props)
            $$invalidate(19, $$scope = $$props.$$scope);
    };
    $$self.$$.update = () => {
        if ($$self.$$.dirty & /*__mounted, __ref, logger*/ 282624) {
            $: if (__mounted)
                setProp(__ref, "logger", logger);
        }
    };
    return [
        className,
        style,
        cookies,
        videoId,
        showFullscreenControl,
        poster,
        language,
        autoplay,
        controls,
        loop,
        muted,
        playsinline,
        __ref,
        onEvent,
        logger,
        getAdapter,
        ref,
        getWebComponent,
        __mounted,
        $$scope,
        slots,
        vm_youtube_binding
    ];
}
class Youtube extends SvelteComponent {
    constructor(options) {
        super();
        init(this, options, instance, create_fragment, safe_not_equal, {
            class: 0,
            style: 1,
            cookies: 2,
            videoId: 3,
            showFullscreenControl: 4,
            poster: 5,
            language: 6,
            autoplay: 7,
            controls: 8,
            logger: 14,
            loop: 9,
            muted: 10,
            playsinline: 11,
            getAdapter: 15,
            ref: 16,
            getWebComponent: 17
        });
    }
    $on(type, callback) {
        return super.$on(type, callback);
    }
    $set($$props) {
        super.$set($$props);
    }
    /**  */
    get getAdapter() {
        return this.$$.ctx[15];
    }
    get ref() {
        return this.$$.ctx[16];
    }
    get getWebComponent() {
        return this.$$.ctx[17];
    }
}
export default Youtube;
//# sourceMappingURL=Youtube.js.map